import { useCallback } from "react";

import { useSelector } from "react-redux";

import { getBusinessRegistrations, getProperties } from "selectors";
import { getBusinessPics } from "selectors/temporaryBusinesses";

// Matches a temporary Business on the details its card shows: name, ABN,
// PICs and primary email.
export function useTemporaryBusinessSearch(searchText: string) {
  const propertyByIdLookup = useSelector(getProperties);
  const registrationsById = useSelector(getBusinessRegistrations);
  const search = searchText.trim().toLowerCase();

  return useCallback(
    (business: Business) => {
      if (!search) {
        return true;
      }
      const searchDigits = search.replace(/\s/g, "");
      return [
        business.name,
        business.registrationId &&
          registrationsById[business.registrationId]?.abn.replace(/\s/g, ""),
        business.primaryContactEmail,
        ...getBusinessPics(business, propertyByIdLookup),
      ].some(value => {
        const text = value?.toLowerCase() ?? "";
        return text.includes(search) || text.includes(searchDigits);
      });
    },
    [search, propertyByIdLookup, registrationsById],
  );
}
